export default function navigateToResetPasswordHandler() {
  const queryParams = new URLSearchParams(window.location.search);
  if (queryParams.get('reset_password')) {
    queryParams.delete('reset_password');
    window.history.replaceState(null, '', `?${queryParams}${window.location.hash}`);
    return true;
  }
  return false;
}
